<template>
    <DropDown :items="columnOptions" title="Columns" emit-event="column-selector-update"
        @column-selector-update="emitNewColumns" />
</template>


<script setup>
import { ref } from 'vue';
import DropDown from '../../DropDown.vue';
const emit = defineEmits()

defineExpose({
    setColumnOptions,
    reset
})

const props = defineProps({
    ignoredKeys: {
        type: Set,
        required: true
    }
})

const columnOptions = ref([])

function setColumnOptions(row) {
    const columnList = [];

    Object.keys(row).forEach(key => {
        if (!props.ignoredKeys.has(key)) {
            columnList.push({
                name: key,
                value: true
            });
        }
    });

    columnOptions.value = columnList;
}

const emitNewColumns = (newColumnData) => {
    emit('on-column-change', newColumnData)
}

function reset() {
    columnOptions.value.forEach(item => {
        item.value = true;
    });
    emitNewColumns(columnOptions.value)
}
</script>